import {Paper as MUIPaper} from '@mui/material'

export const Paper = MUIPaper
